const styles = () => ({});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/GatewayBundle/Details/Header/styles.js